module.exports = __webpack_public_path__ + "img/tips-park.7ae2afa0.svg";